// React Dependencies
import React, { useState, useEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Grid, Button, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { toast } from 'react-toastify';

// Internal Dependencies
import MaterialDatePicker from '../global/form/MaterialDatePicker';
import TimeSelect from '../common/TimeSelect';
import ScreenTakeOver from './screenTakeOver';

const Dates = ({
  activeStep, onActiveStepChanged, dateFrom, dateTill, onChangedDateFrom, onChangedDateTill, onUpdate,
  startTimeHours, startTimeMins, startTimeType, endTimeHours, endTimeMins, endTimeType, isSpecificTime, isScreenTakeOverChecked, setIsScreenTakeOverChecked,
  setStartTimeHours, setStartTimeMins, setStartTimeType, setEndTimeHours, setEndTimeMins, setEndTimeType, onChangeSpecificTime,
}) => {
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [from, setFrom] = useState(dateFrom);
  const [till, setTill] = useState(dateTill);

  const onChangeFrom = (e) => {
    setFrom(e.toISOString());
    onChangedDateFrom(e.toISOString());
  };

  const onChangeTo = (e) => {
    setTill(e.toISOString());
    onChangedDateTill(e.toISOString());
  };

  useEffect(() => {
    setDisableSubmit(false);

    if (new Date(from) > new Date(till)) {
      toast.error(`Promo end date is earlier than current date`);
      setDisableSubmit(true);
    }
  }, [from, till, dateFrom, dateTill]);

  return (
    <div>
      <Grid item container>
        <Grid item>
          <h5>Advertisement Period</h5>
        </Grid>
        <Grid item container direction="row" spacing={2}>
          <Grid item>
            <MaterialDatePicker
              minDate={false}
              label="Starts On"
              value={new Date(from)}
              onChange={(e) => onChangeFrom(e)}
            />
          </Grid>
          <Grid item>
            <MaterialDatePicker
              minDate={false}
              label="Ends On"
              value={new Date(till)}
              onChange={(e) => onChangeTo(e)}
            />
          </Grid>
        </Grid>
      </Grid>

      <div className="mt-4">
        <Typography>Specific daily display time-period</Typography>
        <FormControlLabel
          control={(<Checkbox checked={isSpecificTime} onChange={() => onChangeSpecificTime()} />)}
          label="Show only on specific hours (un-check to display 24hrs)"
          className="ml-3"
        />
      </div>

      <Grid item container direction="row" spacing={3}>
        <TimeSelect
          disabled={!isSpecificTime}
          text="Start Time"
          valueHours={startTimeHours}
          valueMins={startTimeMins}
          valueTimeType={startTimeType}
          onChangeHours={(e) => setStartTimeHours(e.target.value)}
          onChangeMins={(e) => setStartTimeMins(e.target.value)}
          onChangeTimeType={(e) => setStartTimeType(e.target.value)}
        />
        <Grid item className="d-flex flex justify-content-center align-items-center" style={{ position: 'relative', top: 15 }}>
          <Typography>to</Typography>
        </Grid>
        <TimeSelect
          disabled={!isSpecificTime}
          text="End Time"
          valueHours={endTimeHours}
          valueMins={endTimeMins}
          valueTimeType={endTimeType}
          onChangeHours={(e) => setEndTimeHours(e.target.value)}
          onChangeMins={(e) => setEndTimeMins(e.target.value)}
          onChangeTimeType={(e) => setEndTimeType(e.target.value)}
        />
      </Grid>
      <hr />

      <div className="mt-2">
        <ScreenTakeOver
          isChecked={isScreenTakeOverChecked}
          setIsChecked={setIsScreenTakeOverChecked}
        />
        <hr />
      </div>

      <center>
        <Grid item>
          <Button
            onClick={() => onActiveStepChanged(activeStep - 1)}
            style={{ position: 'relative', width: '50%' }}
            variant="contained"
            color="default"
          >
            Back
          </Button>
        </Grid>
        <Grid item style={{ marginTop: 10 }}>
          <Button
            disabled={disableSubmit}
            onClick={(e) => onUpdate(e)}
            style={{ position: 'relative', width: '50%' }}
            variant="contained"
            color="secondary"
          >
            Submit
          </Button>
        </Grid>
      </center>
    </div>
  );
};

export default Dates;

Dates.propTypes = {
  activeStep:                 PropTypes.number.isRequired,
  dateFrom:                   PropTypes.string.isRequired,
  dateTill:                   PropTypes.string.isRequired,
  onActiveStepChanged:        PropTypes.func.isRequired,
  onChangedDateFrom:          PropTypes.func.isRequired,
  onChangedDateTill:          PropTypes.func.isRequired,
  onUpdate:                   PropTypes.func.isRequired,
  startTimeHours:             PropTypes.string,
  startTimeMins:              PropTypes.string,
  startTimeType:              PropTypes.string,
  endTimeHours:               PropTypes.string,
  endTimeMins:                PropTypes.string,
  endTimeType:                PropTypes.string,
  isSpecificTime:             PropTypes.bool.isRequired,
  setStartTimeHours:          PropTypes.func.isRequired,
  setStartTimeMins:           PropTypes.func.isRequired,
  setStartTimeType:           PropTypes.func.isRequired,
  setEndTimeHours:            PropTypes.func.isRequired,
  setEndTimeMins:             PropTypes.func.isRequired,
  setEndTimeType:             PropTypes.func.isRequired,
  onChangeSpecificTime:       PropTypes.func.isRequired,
  isScreenTakeOverChecked:    PropTypes.bool.isRequired,
  setIsScreenTakeOverChecked: PropTypes.func.isRequired,
};

Dates.defaultProps = {
  startTimeHours: null,
  startTimeMins:  null,
  startTimeType:  null,
  endTimeHours:   null,
  endTimeMins:    null,
  endTimeType:    null,
};
